import QuestionModal from '../QuestionModal/QuestionModal';
import { useInternalNavigationPreventOnChange } from '../../../../hooks/useInternalNavigationPreventOnChange';
import PropTypes from 'prop-types';
import { useExternalNavigationPreventOnChange } from '../../../../hooks/useExternalNavigationPreventOnChange';
import { useTranslation } from 'react-i18next';

const UnsavedChangesModal = ({ changesMade }) => {
  const { showPrompt, confirmNavigation, cancelNavigation } =
    useInternalNavigationPreventOnChange(changesMade);
  useExternalNavigationPreventOnChange(changesMade, showPrompt);
  const { t } = useTranslation();

  return (
    <QuestionModal
      visible={showPrompt}
      toggle={cancelNavigation}
      headerTitle={t('Neuložené zmeny')}
      question={t('Máte neuložené zmeny. Naozaj chcete odísť?')}
      chosenPositive={confirmNavigation}
      yes="Áno"
    />
  );
};

UnsavedChangesModal.propTypes = {
  changesMade: PropTypes.bool.isRequired,
};
export default UnsavedChangesModal;
